export { BtnIconSettings2 } from "./BtnIconSettings2";
